import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import HorizontalSpacer from '../../HorizontalSpacer/HorizontalSpacer';
import CountrySelectorItem from './styled/CountrySelectorItem';
import CountrySelectorList from './styled/CountrySelectorList';
import FlagImage from './styled/FlagImage';
import CountrySelectorWrapper from './styled/CountrySelectorWrapper';
import ChevronLarge from './styled/ChevronLarge';
import SelectedCountryWrapper from './styled/SelectedCountryWrapper';
import ChevronWrapper from './styled/ChevronWrapper';

class CountrySelector extends Component {
  constructor(props) {
    super(props);
    this.state = { isExpanded: false };
  }

  componentDidMount() {
    // preload flag images
    this.props.countries.forEach(country => {
      const img = new Image();
      img.src = country.url;
    });
  }

  handleExpand = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  renderSelectedItem = () => {
    const { countries, selectedCountryId } = this.props;
    const { isExpanded } = this.state;

    const selectedCountry = countries.filter(country => country.id === selectedCountryId)[0];
    if (!countries || countries.length === 0 || !selectedCountry) {
      return <></>;
    }
    const imageUrl = get(selectedCountry, 'url', null);

    const chevronClassName = isExpanded ? 'icon-angle-up' : 'icon-angle-down';
    return (
      <SelectedCountryWrapper
        isExpanded={isExpanded}
        onClick={this.handleExpand}
        data-cy="selector-country-size-selected-item"
      >
        <FlagImage src={imageUrl} />
        <HorizontalSpacer style={{ display: 'inline-block' }} width="10px" />
        {selectedCountry.name}
        <ChevronWrapper>
          <ChevronLarge className={chevronClassName} />
        </ChevronWrapper>
      </SelectedCountryWrapper>
    );
  };

  renderListItem = country => {
    const { handleSelection } = this.props;
    const { isExpanded } = this.state;

    return (
      <CountrySelectorItem key={country.id} data-cy="selector-country-size-item">
        <div
          onClick={() => {
            handleSelection(country.id);
            this.setState({ isExpanded: !isExpanded });
          }}
        >
          <FlagImage src={country.url} />
          <HorizontalSpacer style={{ display: 'inline-block' }} width="10px" />
          {country.name}
        </div>
      </CountrySelectorItem>
    );
  };

  renderList = () => {
    const { countries, selectedCountryId } = this.props;

    const notSelectedCountries = countries.filter(country => country.id !== selectedCountryId);

    return (
      <CountrySelectorList>{notSelectedCountries.map(country => this.renderListItem(country))}</CountrySelectorList>
    );
  };

  render() {
    const { isExpanded } = this.state;

    return (
      <CountrySelectorWrapper data-cy="selector-country-size">
        {this.renderSelectedItem()}
        {isExpanded && this.renderList()}
      </CountrySelectorWrapper>
    );
  }
}

CountrySelector.propTypes = {
  handleSelection: PropTypes.func.isRequired,
  selectedCountryId: PropTypes.string.isRequired,
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default CountrySelector;
